// extracted by mini-css-extract-plugin
export default {"container":"UF-z","disabled":"VF-z","bgBlack":"WF-z","content":"XF-z","countdown":"YF-z","topCaption":"ZF-z","topHeading":"_F-z","heading":"aG-z","copy":"bG-z"};